import {sortBy} from 'lodash';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';

/**
 * Returns an array of connections for a given event, optionally filtered and sorted.
 *
 * @param {number} eventId - The ID of the event.
 * @param {Object} options - An optional object containing filter and sortBy functions.
 * @param {function} options.filter - A function that filters the connections array.
 * @param {function} options.sortBy - A function that sorts the connections array.
 * @return {Array} - An array of connections for the given event, optionally filtered and sorted.
 */
export function useEventConnections(eventId, {filter, sortBy: sortFunction} = {}) {
    const connections = useSelector(state => state.events[eventId]?.connections.listed) ?? [];

    return useMemo(() => {
        let result = connections;

        if (filter) result = result.filter(filter);
        if (sortBy) result = sortBy(result, sortFunction);

        return result;
    }, [connections, filter, sortBy]);
}
